<template>
    <div style="width: 100%; position: relative">
        <div :class="definirClasseBarraStatus()"/>

        <div class="observador">
            <div style="display: block !important;">
                <div class="cabecalho">
                    <div class="linha-observador ellipsis">
                        <template>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" :color="observador.dataEnvioEmail ? '#72cb72' : '#aaa'">mdi-email</v-icon>
                                </template>
                                <span v-if="!ehEmailEnviado">Aguardando formalização</span>
                                <span v-else>E-mail enviado</span>
                            </v-tooltip>
                        </template>

                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <span v-on="on"> {{ observador.email }}</span>
                            </template>
                            <span>{{ observador.email }}</span>
                        </v-tooltip>
                    </div>

                    <div class="linha-observador" v-if="!ehEmailEnviado" style="color: #aaa">
                        <v-icon style="color: #ccc">mdi-clock-outline</v-icon>
                        <span>Aguardando formalização</span>
                    </div>

                    <div v-else class="linha-observador">
                        <v-icon style="color: #72cb72">mdi-check-circle</v-icon>

                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <span v-on="on">E-mail enviado</span>
                            </template>
                            <span>Em {{ observador.dataEnvioEmail | azDate('DD/MM/YYYY HH:mm:ss') }}</span>
                        </v-tooltip>
                    </div>

                </div>
            </div>

            <div v-if="!ehOcultarBotoesAcoes" style="display: flex; align-items: center;">
                <div class="acoes" style="margin-right: 17px !important;">
                    <div class="acoes">
                        <div style="margin-top: 2px; margin-right: 3px">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon @click="removerObservador" v-on="on" color="primary" size="24px">mdi-delete</v-icon>
                                </template>
                                <span>Remover observador</span>
                            </v-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapState} from 'vuex'

export default {
    name: 'Observador',
    props: {
        observador: {
            required: true
        }
    },
    computed: {
        ...mapState(['minutaAtual']),
        ehEmailEnviado() {
            return !!this.observador.dataEnvioEmail
        },
        ehContratoExtintoArquivado() {
            return this.minutaAtual.contratoArquivado || this.minutaAtual.contratoExtinto
        },
        ehMinutaCancelada() {
            return this.minutaAtual.situacaoFormalizacao === 'CANCELADO'
        },
        ehMinutaFormalizada() {
            return this.minutaAtual.situacaoFormalizacao === 'FORMALIZADO'
        },
        ehMinutaCanceladaFormalizada() {
            return this.ehMinutaCancelada || this.ehMinutaFormalizada
        },
        ehOcultarBotoesAcoes() {
            return this.ehMinutaCanceladaFormalizada || this.ehContratoExtintoArquivado
        }
    },
    methods: {
        definirClasseBarraStatus() {
            if (!this.ehEmailEnviado) {
                return 'barra-status-aguardando-envio'
            } {
                return 'barra-status-enviado'
            }
        },
        removerObservador() {
            this.$emit('removerObservador', this.observador)
        }
    }
}
</script>
<style lang="stylus" scoped>
.barra-status
    &-enviado
        background-color: #72cb72
        width: 8px
        height: 100%
        position: absolute
        left: 0

    &-aguardando-envio
        background-color: #ccc
        width: 8px
        height: 100%
        position: absolute
        left: 0

.linha-observador
    font-size 13px
    color #aaa
    font-weight normal !important
    padding-left 7px

    i
        font-size 16px !important
        margin-right 5px
        font-weight normal !important

.observador
    border-bottom: 1px solid #ddd !important;
    display flex
    padding: 10px 0 10px 15px
    justify-content space-between
    border-bottom 1px solid #ccc

    .acoes
        display flex
        align-items center

        button
            margin 0 !important

    .ellipsis
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap

        .barra-status
            width 8px
            height 48px

        .cabecalho
            display block
            width: 100%;
            padding 5px 12px 0 12px
            justify-content flex-end
            padding-right 10px
            margin-top 5px
</style>